export const keywords = [
  'timeline',
  'strategy',
  'segment',
  'experiment',
  'description',
  'start_date',
  'end_date',
  'condition',
  'rollout',
  'dpad',
  'experiment_key',
  'intent',
  'goal',
  'init_time',
  'actions',
  'pre_action',
  'intent',
  'init_time',
  'product_codes',
  'anchor_date'
];

export const theme = {
  base: 'vs',
  inherit: true,

  rules: [
    { token: 'keyword', foreground: '#FF6600', fontStyle: 'bold' },
    { token: 'variable', foreground: '#006699' },
    { token: 'string', foreground: '#009966' },
    { token: 'comment', foreground: '#999999' }
  ],
  colors: {
    'editor.background': '#FFFFFF',
    'editor.foreground': '#000000'
  }
};

export const languageConfig = {
  keywords,
  tokenizer: {
    root: [
      [/@?[a-zA-Z][\w$]*/, { cases: { '@keywords': 'keyword', '@default': 'variable' } }],
      [/".*?"/, 'string'],
      [/\/\//, 'comment']
    ]
  }
};
